import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import auth from '@/store/modules/auth'

const dataState = new createPersistedState({
    //Persistimos únicamente las variables que necesitamos
    reducer: (state) => ({
        auth: {
            token: state.auth.token,
            refreshToken: state.auth.refreshToken
        }
    })
})

export default createStore({
    plugins: [dataState],
    state: {
        isLoading: false,
        navbarRefreshKey: 0
    },
    mutations: {
        setLoading(state, bool) {
            state.isLoading = bool
        },
        refreshNavbar(state) {
            state.navbarRefreshKey += 1
        }
    },
    actions: {
        setLoading({ commit }, isLoading) {
            commit('setLoading', isLoading, { root: true })
        },
        refreshNavbar({ commit }) {
            commit('refreshNavbar')
        }
    },
    modules: {
        auth
    }
})
